import Map from 'ol/Map.js';
import OSM from 'ol/source/OSM.js';
import TileLayer from 'ol/layer/Tile.js';
import View from 'ol/View.js';
import WMTS from 'ol/source/WMTS.js';
import WMTSTileGrid from 'ol/tilegrid/WMTS.js';
import { get as getProjection } from 'ol/proj.js';
import { getTopLeft, getWidth } from 'ol/extent.js';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4.js';

import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import GeoJSON from 'ol/format/GeoJSON.js';

import { Circle as CircleStyle, Icon, Fill, Stroke, Style } from 'ol/style.js';
import { OverviewMap, ScaleLine, defaults as defaultControls } from 'ol/control.js';
//import TileWMS from 'ol/source/TileWMS.js';
//import WFS from 'ol/format/WFS.js';
//import {
//    and as andFilter,
//    equalTo as equalToFilter,
//    like as likeFilter,
//} from 'ol/format/filter.js';
import TileWMS from 'ol/source/TileWMS.js';


import getExistingLayer from './js/helper.js';

const mapVersion = "1.4.5 Devel (27.5.2026)";

const projection = getProjection('EPSG:3857');
const projectionExtent = projection.getExtent();

// Transparent Proj4js support:
proj4.defs("EPSG:5514", "+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=570.8,85.7,462.8,4.998,1.587,5.261,3.56 +units=m +no_defs");

register(proj4);

const JTSKprojection = getProjection('EPSG:5514');
JTSKprojection.extend = [-907841.0560214706, -1230916.868999999, -416691.670278527, -932111.7296999972];

var mapCenter = [-725744.38828, -1081015.72104];
var mapZoom = 11;
var startChoosen = false, endChoosen = false, middleChoosen = false;

if (typeof mapConfiguration === 'undefined') {
    console.error("Ve strance chybi mapConfiguration promena");
}
else
    console.log("Map " + mapVersion + " initializing", mapConfiguration);


if (mapConfiguration.zoom != null) {
    if (mapConfiguration.debug) console.log("Pouziji zoom", mapConfiguration.zoom);
    mapZoom = mapConfiguration.zoom;
}

if (mapConfiguration.coordinates != null) {
    if (mapConfiguration.debug) console.log("Pouziji coordinates", mapConfiguration.coordinates);
    mapCenter = mapConfiguration.coordinates;
}

const size = getWidth(projectionExtent) / 256;
const resolutions = new Array(19);
const matrixIds = new Array(19);
for (let z = 0; z < 19; ++z) {
    // generate resolutions and matrixIds arrays for this WMTS
    resolutions[z] = size / Math.pow(2, z);
    matrixIds[z] = z;
}

// definice bodu
const image = new CircleStyle({
    radius: 5,
    fill: null,
    stroke: new Stroke({ color: 'red', width: 1 }),
});

// Definice Obarveni linii a objektu
const stylesTrip = {
    'Point': new Style({
        image: image,
    }),
    'LineString': new Style({
        stroke: new Stroke({
            color: 'red',
            width: 3,
        }),
    }),
    'MultiLineString': new Style({
        stroke: new Stroke({
            color: 'green',
            width: 3,
        }),
    }),
    'MultiPoint': new Style({
        image: image,
    }),
    'MultiPolygon': new Style({
        stroke: new Stroke({
            color: 'yellow',
            width: 1,
        }),
        fill: new Fill({
            color: 'rgba(255, 255, 0, 0.1)',
        }),
    }),
    'Polygon': new Style({
        stroke: new Stroke({
            color: 'red',
            lineDash: [4],
            width: 3,
        }),
        fill: new Fill({
            color: 'rgba(0, 0, 255, 0.1)',
        }),
    }),
    'GeometryCollection': new Style({
        stroke: new Stroke({
            color: 'magenta',
            width: 2,
        }),
        fill: new Fill({
            color: 'magenta',
        }),
        image: new CircleStyle({
            radius: 10,
            fill: null,
            stroke: new Stroke({
                color: 'magenta',
            }),
        }),
    }),
    'Circle': new Style({
        stroke: new Stroke({
            color: 'red',
            width: 2,
        }),
        fill: new Fill({
            color: 'rgba(255,0,0,0.2)',
        }),
    }),
};

// Obarveni linii a objektu
const styleTripFunction = function (feature) {
    console.debug("styleTripFunction", feature.getGeometry().getType());
    return stylesTrip[feature.getGeometry().getType()];
};

// WMTS - Ortofoto �R - m���tkov� �ada Google Maps
const ortoLayer = new TileLayer({
    source: new WMTS({
        url: 'https://ags.cuzk.cz/arcgis1/rest/services/ORTOFOTO_WM/MapServer/WMTS',
        matrixSet: 'GoogleMapsCompatible',
        format: 'image/png',
        projection: projection,
        tileGrid: new WMTSTileGrid({
            origin: getTopLeft(projectionExtent),
            resolutions: resolutions,
            matrixIds: matrixIds,
        }),
        style: 'default',
        wrapX: true,
    }),
});

// WMTS - Z�kladn� topografick� mapy �R - m���tkov� �ada Google Maps
const topoLayer = new TileLayer({
    source: new WMTS({
        opacity: 0.5,
        //attributions:
        //    'Tiles � <a href="https://mrdata.usgs.gov/geology/state/"' +
        //    ' target="_blank">USGS</a>',
        url: 'https://ags.cuzk.cz/arcgis1/rest/services/ZTM_WM/MapServer/WMTS',
        layer: 'DEF_BUDOVY',
        matrixSet: 'GoogleMapsCompatible',
        format: 'image/png',
        projection: projection,
        tileGrid: new WMTSTileGrid({
            origin: getTopLeft(projectionExtent),
            resolutions: resolutions,
            matrixIds: matrixIds,
        }),
        style: 'default',
        wrapX: true,
    }),
});

// OSM
const osmLayer = new TileLayer({
    source: new OSM(),
});

// PlavebniUrad
//const plavebniUradLayer = new TileLayer({
//    extent: [-895948.43, -1227766.9872, -454324.39, -953014.631],
//    source: new TileWMS({
//        url: 'https://geoportal.plavebniurad.cz/arcgis/services/VodniCestyCR_WMS_JTSK/MapServer/WMSServer',
//        params: { 'LAYERS': '1,6,13,14,22,28,30,34', 'TILED': true },
//        serverType: 'geoserver',
//        transition: 0,
//        opacity: 1,
//    }),
//    name: 'plavebniurad'
//});

ortoLayer.setVisible(false);
topoLayer.setVisible(false);

const PoisFunction = function (tripPoisUrl, name) {
    return new VectorLayer({
        source: new VectorSource({
            url: tripPoisUrl,
            format: new GeoJSON(),
            projection: JTSKprojection,
        }),
        name: name,
        style: PoiStyleFunction,
    });
}


const PoiStyleFunction = function (feature) {
    var actualZoom = map.getView().getZoom();
    var iconUrl = feature.get('iconUrl');
    if (actualZoom < 12.5 && actualZoom > 11.5) iconUrl = iconUrl.replace("c.gif", "b.gif").replace("c.png", "b.png");
    if (actualZoom <= 11.5) iconUrl = iconUrl.replace("c.gif", "a.gif").replace("c.png", "a.png");
    var defaultStyle = new Style({
        image: iconUrl ? new Icon({
            scale: actualZoom * 10 / 130,
            src: iconUrl
        }) : undefined
    });
    return [defaultStyle];
}

const overviewMapControl = new OverviewMap({
    className: 'ol-overviewmap ol-custom-overviewmap',
    layers: [
        new TileLayer({
            source: new OSM(),
        }),
    ],
    extent: [-895948.43, -1227766.9872, -454324.39, -953014.631],
    collapsed: false,
});

var layers = [
    ortoLayer,
    topoLayer,
    osmLayer
];

// Pesi trasy
if (mapConfiguration.bnHelpWmsLayer != null) {
    if (mapConfiguration.debug) console.log("Zobrazim WMS z BnHelp", mapConfiguration.bnHelpWmsLayer);

    const bnHelpWmsLayer = new TileLayer({
        extent: [-895948.43, -1227766.9872, -454324.39, -953014.631],
        source: new TileWMS({
            url: mapConfiguration.bnHelpWmsLayerUrl,
            params: { 'LAYERS': mapConfiguration.bnHelpWmsLayer, 'TILED': true },
            serverType: 'geoserver',
            transition: 0,
            opacity: 1,
        }),
        name: 'BnHelpWmsLayer'
    });
    layers.push(bnHelpWmsLayer);
}
else {
    if (mapConfiguration.debug) console.log("Nepracuji s WMS z BnHelp");
}


//Zobrazeni Regionu
if (mapConfiguration.regionId != null) {
    if (mapConfiguration.debug) console.log("Zobrazim region", mapConfiguration.regionId);

    const RegionArea = new VectorLayer({
        style: mapConfiguration.regionStyle,
        source: new VectorSource({
            url: mapConfiguration.regionArea,
            format: new GeoJSON()
        }),
        name: 'RegionArea'
    });

    RegionArea.getSource().on('featuresloadstart', function () {
        console.log("RegionArea features load start");
    });

    RegionArea.getSource().on('featuresloaderror', function (e) {
        console.error("RegionArea features load error", e);
    });

    RegionArea.getSource().on('featuresloadend', function (e) {
        console.log("RegionArea features load end", e);
        if (mapConfiguration.cyclingRouteId == null && mapConfiguration.natureTrailId == null) {
            var features = RegionArea.getSource().getFeatures();
            features.forEach(function (feature) {
                map.getView().fit(feature.getGeometry(), { padding: [30, 20, 30, 20] });
            });
        }
    });

    layers.push(RegionArea);
}
else {
    if (mapConfiguration.debug) console.log("Nepracuji s oblasti regionu");
}

/*
//Zobrazeni MicroRegionu
//if (mapConfiguration.microregionId != null) {
//    if (mapConfiguration.debug) console.log("Zobrazim microregion", mapConfiguration.microregionId);

//    const MicroRegionArea = new VectorLayer({
//        style: mapConfiguration.microregionStyle,
//        source: new VectorSource({
//            url: mapConfiguration.microregionArea,
//            format: new GeoJSON()
//        }),
//        name: 'MicroRegionArea'
//    });

//    MicroRegionArea.getSource().on('featuresloadstart', function () {
//        console.log("MicroRegionArea features load start");
//    });

//    MicroRegionArea.getSource().on('featuresloaderror', function (e) {
//        console.error("MicroRegionArea features load error", e);
//    });

//    MicroRegionArea.getSource().on('featuresloadend', function (e) {
//        console.log("MicroRegionArea features load end", e);
//        var features = MicroRegionArea.getSource().getFeatures();
//        features.forEach(function (feature) {
//            map.getView().fit(feature.getGeometry(), { padding: [30, 20, 30, 20] });
//        });
//    });

//    layers.push(MicroRegionArea);
//}
//else {
//    if (mapConfiguration.debug) console.log("Nepracuji s oblasti regionu");
//}


//Zobrazeni Obce - asi neni ted treba
if (mapConfiguration.cityId != null) {
    if (mapConfiguration.debug) console.log("Zobrazim obec", mapConfiguration.cityId);

    const CityArea = new VectorLayer({
        style: mapConfiguration.cityStyle,
        source: new VectorSource({
            url: mapConfiguration.cityArea,
            format: new GeoJSON()
        }),
        name: 'CityArea'
    });

    CityArea.getSource().on('featuresloadstart', function () {
        console.log("CityArea features load start");
    });

    CityArea.getSource().on('featuresloaderror', function (e) {
        console.error("CityArea features load error", e);
    });

    CityArea.getSource().on('featuresloadend', function (e) {
        console.log("CityArea features load end", e);
        var features = CityArea.getSource().getFeatures();
        features.forEach(function (feature) {
            map.getView().fit(feature.getGeometry(), { padding: [30, 20, 30, 20] });
        });
    });

    layers.push(CityArea);
}
else {
    if (mapConfiguration.debug) console.log("Nepracuji s oblasti obce");
}
*/


// Cyklotrasy
if (mapConfiguration.cyclingRouteId != null) {
    if (mapConfiguration.debug) console.log("Zobrazim linii cyklisticke trasy", mapConfiguration.cyclingRouteId);

    const CyclingRouteLinie = new VectorLayer({
        style: styleTripFunction,
        source: new VectorSource({
            url: mapConfiguration.cyclingRouteLine,
            format: new GeoJSON()
        }),
        name: 'CyclingRouteLinie'
    });

    CyclingRouteLinie.getSource().on('featuresloadstart', function () {
        console.log("CyclingRouteLinie features load start");
    });

    CyclingRouteLinie.getSource().on('featuresloaderror', function (e) {
        console.error("CyclingRouteLinie features load error", e);
    });

    CyclingRouteLinie.getSource().on('featuresloadend', function (e) {
        console.log("CyclingRouteLinie features load end", e);
        var features = CyclingRouteLinie.getSource().getFeatures();
        features.forEach(function (feature) {
            map.getView().fit(feature.getGeometry(), { padding: [30, 20, 30, 20] });
        });
    });

    if (mapConfiguration.cyclingRoutePois) {

        const CyclingRoutePois = new VectorLayer({
            source: new VectorSource({
                url: mapConfiguration.cyclingRoutePois,
                format: new GeoJSON(),
                projection: JTSKprojection,
            }),
            name: 'CyclingRoutePois',
            style: PoiStyleFunction,
        });

        CyclingRoutePois.getSource().on('featuresloadstart', function () {
            console.log("CyclingRoutePois features load start");
        });

        CyclingRoutePois.getSource().on('featuresloaderror', function (e) {
            console.error("CyclingRoutePois features load error", e);
        });

        CyclingRoutePois.getSource().on('featuresloadend', function (e) {
            console.log("CyclingRoutePois features load end", e);
        });

        if (typeof getTripFilterSelected === 'function') {
            var url = mapConfiguration.cyclingRoutePois() + "&Filter=" + getTripFilterSelected();
            CyclingRoutePois.getSource().setUrl(url);
            CyclingRoutePois.getSource().refresh();
        }
        else {
            console.warn("Mapy - neexistuje funkce getTripFilterSelected");
        }

        layers.push(CyclingRoutePois);
    }

    layers.push(CyclingRouteLinie);


    /* pois category selection change */
    if (typeof tripFilterEventListener === 'function') {
        console.log("Mapy - mam funkci tripFilterEventListener, zapojim filtrovani");
        tripFilterEventListener(filterCyclingRouteClick);
    }
    else {
        console.warn("Mapy - neexistuje funkce tripFilterEventListener, nepujde filtrovat");
    }

    function filterCyclingRouteClick() {
        console.log("Mapy.filterCyclingRouteClick - CLICKED filter for pois category");
        if (typeof getTripFilterSelected === 'function') {
            CyclingRoutePois.getSource().setUrl(mapConfiguration.cyclingRoutePois + "&Filter=" + getTripFilterSelected());
            CyclingRoutePois.getSource().refresh();
        }
        else {
            console.error("Mapy - neexistuje funkce getTripFilterSelected");
        }
    }
}
else {
    if (mapConfiguration.debug) console.log("Nepracuji s linii cyklisticke trasy");
}

// NAucne stezky
if (mapConfiguration.natureTrailId != null) {
    if (mapConfiguration.debug) console.log("Zobrazim linii naucne stezky", mapConfiguration.natureTrailId);


    // generate a GetFeature request
    //const featureRequest = new WFS().writeGetFeature({
    //    srsName: 'EPSG:3857',
    //    //featureNS: 'https://hsmap.bnhelp.cz/cgi-bin/wms_posazavi',
    //    //featurePrefix: 'osm',
    //    featureTypes: ['naucne'],
    //    outputFormat: 'application/json',
    //    filter: //andFilter(
    //        //likeFilter('name', 'Mississippi*'),
    //        equalToFilter('id_trasy', mapConfiguration.natureTrailId),
    //    //),
    //});

    const NatureTrailLinie = new VectorLayer({
        style: styleTripFunction,
        source: new VectorSource({
            url: mapConfiguration.natureTrailWms,
            format: new GeoJSON()
        }),
        name: 'NatureTrailLinie'
    });

    NatureTrailLinie.getSource().on('featuresloadstart', function () {
        console.log("NatureTrailLinie features load start");
    });

    NatureTrailLinie.getSource().on('featuresloaderror', function (e) {
        console.error("NatureTrailLinie features load error", e);
    });

    NatureTrailLinie.getSource().on('featuresloadend', function (e) {
        console.log("NatureTrailLinie features load end", e);
        var features = NatureTrailLinie.getSource().getFeatures();
        features.forEach(function (feature) {
            map.getView().fit(feature.getGeometry(), { padding: [30, 20, 30, 20] });
        });
    });

    if (mapConfiguration.natureTrailPois) {

        const NatureTrailPois = new VectorLayer({
            source: new VectorSource({
                url: mapConfiguration.natureTrailPois,
                format: new GeoJSON(),
                projection: JTSKprojection,
            }),
            name: 'NatureTrailPois',
            style: PoiStyleFunction,
        });

        NatureTrailPois.getSource().on('featuresloadstart', function () {
            console.log("NatureTrailPois features load start");
        });

        NatureTrailPois.getSource().on('featuresloaderror', function (e) {
            console.error("NatureTrailPois features load error", e);
        });

        NatureTrailPois.getSource().on('featuresloadend', function (e) {
            console.log("NatureTrailPois features load end", e);
        });
               

        layers.push(NatureTrailPois);
    }

    layers.push(NatureTrailLinie);
}
else {
    if (mapConfiguration.debug) console.log("Nepracuji s linii naucne stezky");
}

const map = new Map({
    layers: layers,
    controls: defaultControls().extend([new ScaleLine()]).extend([overviewMapControl]),
    target: document.getElementById('map'),
    view: new View({
        projection: JTSKprojection,
        center: mapCenter, //[-745663.222138402, -1072290.33303615],
        extent: JTSKprojection.extend, // [-907841.0560214706, -1230916.868999999, -416691.670278527, -932111.7296999972],
        zoom: mapZoom
    }),
});

console.log("Map " + mapVersion + " initialized", mapCenter, mapZoom);

//Odchyceni eventu outside from map
document.getElementById('map').addEventListener('showBnHelpWms', function (e) {
    console.log("Map: Called showBnHelpWms outside from map for layer", e.detail);

    var foundExistingLayer = getExistingLayer(map.getAllLayers(), "BnHelpWmsLayer");
    console.log("Map: existuje vrstva BnHelpWmsLayer", foundExistingLayer != null);
    if (foundExistingLayer != null) {
        var lname = foundExistingLayer.get("name");
        map.removeLayer(foundExistingLayer);

        const bnHelpWmsLayer = new TileLayer({
            extent: [-895948.43, -1227766.9872, -454324.39, -953014.631],
            source: new TileWMS({
                url: mapConfiguration.bnHelpWmsLayerUrl,
                params: { 'LAYERS': e.detail, 'TILED': true },
                serverType: 'geoserver',
                transition: 0,
                opacity: 1,
            }),
            name: 'BnHelpWmsLayer'
        });
        //var l = getVectorLayerCityArea(e.detail, { 'fill-color': '#00ff0044' });
        map.addLayer(bnHelpWmsLayer);
    }
});



document.getElementById('map').addEventListener('showCity', function (e) {
    console.log("Map: Called showCity outside from map for city", e.detail);

    var foundRegionArea = getExistingLayer(map.getAllLayers(), "RegionArea");
    console.log("Map: existuje vrstva RegionArea", foundRegionArea != null);
    if (foundRegionArea != null) foundRegionArea.setVisible(0);

    var foundExistingLayer = getExistingLayer(map.getAllLayers(), "CityArea");
    console.log("Map: existuje vrstva CityArea", foundExistingLayer != null);
    if (foundExistingLayer != null) {
        var lname = foundExistingLayer.get("name");
        map.removeLayer(foundExistingLayer);
        var l = getVectorLayerCityArea(e.detail, { 'fill-color': '#00ff0044' });
        map.addLayer(l);
    //    foundExistingLayer.setVisible(1);
    //    var features = foundExistingLayer.getSource().getFeatures();
    //    features.forEach(function (feature) {
    //        map.getView().fit(feature.getGeometry(), { padding: [30, 20, 30, 20] });
    //    });
    }
    else {
        var l = getVectorLayerCityArea(e.detail, { 'fill-color': '#00ff0044' });
        map.addLayer(l);
    }

    reloadPoisLayers(e.detail, 0, map);
});

document.getElementById('map').addEventListener('showRegion', function (e) {
    console.log("Map: Called showRegion outside from map for region", e.detail);

    var foundCity = getExistingLayer(map.getAllLayers(), "CityArea");
    console.log("Map: existuje vrstva CityArea", foundCity != null);
    if (foundCity != null) foundCity.setVisible(0);

    var foundExistingLayer = getExistingLayer(map.getAllLayers(), "RegionArea");
    console.log("Map: existuje vrstva RegionArea", foundExistingLayer != null);

    if (foundExistingLayer != null) {
        var lname = foundExistingLayer.get("name");
        map.removeLayer(foundExistingLayer);
        var l = getVectorLayerRegionArea(e.detail, mapConfiguration.regionStyle);
        map.addLayer(l);

        //foundExistingLayer.setVisible(1);
        //var features = foundExistingLayer.getSource().getFeatures();
    //    features.forEach(function (feature) {
    //        map.getView().fit(feature.getGeometry(), { padding: [30, 20, 30, 20] });
    //    });
    }
    else {
        var l = getVectorLayerRegionArea(e.detail, mapConfiguration.regionStyle);
        map.addLayer(l);
    }

    reloadPoisLayers(0, e.detail, map);

});

document.getElementById('map').addEventListener('showMemoryCategory', function (e) {
    console.log("Map: Called showMemoryCategory outside from map for memoryCategory", e.detail);
    var foundExistingLayer = getExistingLayer(map.getAllLayers(), "MemoryCategory" + e.detail);
    console.log("Map: existuje vrstva MemoryCategory" + e.detail, foundExistingLayer != null);
    if (foundExistingLayer == null) //map.removeLayer(foundExistingLayer);
    {
        console.log("Map: Vrstva neexistuje, pridavam");
        var l = getDatabasePoisLayer("MemoryCategory" + e.detail, 0, 0, PoiStyleFunction);
        map.addLayer(l);
        l.setVisible(true);
    }
    else {
        foundExistingLayer.setVisible(1);
        console.log("Map: Nastavuji viditelnost exisatujici vrstvy");
    }
});

document.getElementById('map').addEventListener('hideMemoryCategory', function (e) {
    console.log("Map: Called hideMemoryCategory outside from map for memoryCategory", e.detail);
    var foundExistingLayer = getExistingLayer(map.getAllLayers(), "MemoryCategory" + e.detail);
    foundExistingLayer.setVisible(0);
});

document.getElementById('map').addEventListener('showServiceCategory', function (e) {
    console.log("Map: Called showServiceCategory outside from map for serviceCategory", e.detail);
    var foundExistingLayer = getExistingLayer(map.getAllLayers(), "ServiceCategory" + e.detail);
    console.log("Map: existuje vrstva ServiceCategory" + e.detail, foundExistingLayer != null);
    if (foundExistingLayer == null) //map.removeLayer(foundExistingLayer);
    {
        console.log("Map: Vrstva neexistuje, pridavam");
        var l = getDatabasePoisLayer("ServiceCategory" + e.detail, 0, 0, PoiStyleFunction);
        map.addLayer(l);
        l.setVisible(true);
    }
    else {
        foundExistingLayer.setVisible(1);
        console.log("Map: Nastavuji viditelnost exisatujici vrstvy");
    }
});

document.getElementById('map').addEventListener('hideServiceCategory', function (e) {
    console.log("Map: Called hideServiceCategory outside from map for serviceCategory", e.detail);
    var foundExistingLayer = getExistingLayer(map.getAllLayers(), "ServiceCategory" + e.detail);
    foundExistingLayer.setVisible(0);
});

function getDatabasePoisLayer(name, cityId, regionId, style) {
    var url = mapConfiguration.settings.databasePoisUrl + "?layer=" + name + "&cityId=" + cityId + "&regionId=" + regionId;
    const newLayer = new VectorLayer({
        source: new VectorSource({
            url: url,
            format: new GeoJSON(),
            projection: JTSKprojection,
        }),
        name: name,
        style: style,
    });

    newLayer.getSource().on('featuresloadstart', function () {
        console.log(name + " features load start");
    });

    newLayer.getSource().on('featuresloaderror', function (e) {
        console.error(name + " features load error", e);
    });

    newLayer.getSource().on('featuresloadend', function (e) {
        console.log(name + " features load end", e);
    });

    return newLayer;
}

function reloadPoisLayers(cityId, regionId, map) {
    console.log("reloadPoisLayers", cityId, regionId, map);
    $(map.getAllLayers()).each(function (i, key) {
        var lname = key.get("name");
        //console.log("reloadPoisLayers - testuji vsrtvu :", lname);
        if (lname !== undefined) {
            if (lname.startsWith("MemoryCategory")) {
                var visible = key.getVisible();
                map.removeLayer(key);
                //var url = mapConfiguration.settings.databasePoisUrl + "?layer=" + lname + "&cityId=" + cityId + "&regionId=" + regionId;
                var l = getDatabasePoisLayer(lname, cityId, regionId, PoiStyleFunction);
                if (!visible) l.setVisible(0);
                map.addLayer(l);
            }
            if (lname.startsWith("ServiceCategory")) {
                var visible = key.getVisible();
                map.removeLayer(key);
                //var url = mapConfiguration.settings.databasePoisUrl + "?layer=" + lname + "&cityId=" + cityId;
                var l = getDatabasePoisLayer(lname, cityId, regionId, PoiStyleFunction);
                if (!visible) l.setVisible(0);
                map.addLayer(l);
            }
        }
    });
}

function getVectorLayerRegionArea(regionId, regionStyle) {
    var url = mapConfiguration.dataServiceUrl + 'GeoJson/Region/Area.ashx?Id=' + regionId;
    const RegionArea = new VectorLayer({
        style: regionStyle,
        source: new VectorSource({
            url: url,
            format: new GeoJSON()
        }),
        name: 'RegionArea'
    });

    RegionArea.getSource().on('featuresloadstart', function () {
        console.log("RegionArea features load start");
    });

    RegionArea.getSource().on('featuresloaderror', function (e) {
        console.error("RegionArea features load error", e);
    });

    RegionArea.getSource().on('featuresloadend', function (e) {
        console.log("RegionArea features load end", e);
        var features = RegionArea.getSource().getFeatures();
        features.forEach(function (feature) {
            map.getView().fit(feature.getGeometry(), { padding: [30, 20, 30, 20] });
        });
    });

    return RegionArea;
}

function getVectorLayerCityArea(cityId, cityStyle) {
    var url = mapConfiguration.dataServiceUrl + 'GeoJson/City/Area.ashx?Id=' + cityId;
    const CityArea = new VectorLayer({
        style: cityStyle,
        source: new VectorSource({
            url: url,
            format: new GeoJSON()
        }),
        name: 'CityArea'
    });

    CityArea.getSource().on('featuresloadstart', function () {
        console.log("RegionArea features load start");
    });

    CityArea.getSource().on('featuresloaderror', function (e) {
        console.error("RegionArea features load error", e);
    });

    CityArea.getSource().on('featuresloadend', function (e) {
        console.log("CityArea features load end", e);
        var features = CityArea.getSource().getFeatures();
        features.forEach(function (feature) {
            map.getView().fit(feature.getGeometry(), { padding: [30, 20, 30, 20] });
        });
    });

    return CityArea;
}

/* zoom */
var currZoom = map.getView().getZoom();
map.on('moveend', function (e) {
    var newZoom = map.getView().getZoom();
    if (currZoom != newZoom) {
        console.log('zoom end, new zoom: ' + newZoom);
        currZoom = newZoom;
    }
});

/* popup */

// change mouse cursor when over marker
map.on('pointermove', function (e) {
    const pixel = map.getEventPixel(e.originalEvent);
    const hit = map.hasFeatureAtPixel(pixel);
    map.getTarget().style.cursor = hit ? 'pointer' : '';
});


/* tooltip */
map.on('pointermove', function (evt) {
    if (evt.dragging) {
        mapTooltip.style.visibility = 'hidden';
        currentFeature = undefined;
        return;
    }
    const pixel = map.getEventPixel(evt.originalEvent);
    displayFeatureInfo(pixel, evt.originalEvent.target);
});

const mapTooltip = document.getElementById('mapTooltip');

let currentFeature;
const displayFeatureInfo = function (pixel, target) {
    const feature = target.closest('.ol-control')
        ? undefined
        : map.forEachFeatureAtPixel(pixel, function (feature) {
            return feature;
        });
    if (feature) {
        mapTooltip.style.left = pixel[0] + 'px';
        mapTooltip.style.top = pixel[1] + 'px';
        if (feature !== currentFeature) {
            mapTooltip.style.visibility = 'visible';
            mapTooltip.innerText = feature.get('name');
        }
    } else {
        mapTooltip.style.visibility = 'hidden';
    }
    currentFeature = feature;
};

// Prepinani podkladove mapy

document.getElementById("showMapTopo").addEventListener('click', function () {
    // console.log(map.layer("osmLayer"));
    ortoLayer.setVisible(false);
    osmLayer.setVisible(false);
    topoLayer.setVisible(true);
    console.log("switching map to topo");
});

document.getElementById("showMapOrto").addEventListener('click', function () {
    ortoLayer.setVisible(true);
    topoLayer.setVisible(false);
    osmLayer.setVisible(false);
    console.log("switching map to orto");
});

document.getElementById("showMapOsm").addEventListener('click', function () {
    ortoLayer.setVisible(false);
    topoLayer.setVisible(false);
    osmLayer.setVisible(true);
    console.log("switching map to osm");
});

document.dispatchEvent(new CustomEvent("mapInitialized", {}));
